import React from "react";
import "./CertificateDetails.css";
import CertificationTimeline from "./CertificationTimeline";

function CertificateDetails() {
  return (
    <div>
      <CertificationTimeline />
    </div>
  );
}

export default CertificateDetails;
